import { render } from "./TNovoProfissional.vue?vue&type=template&id=672b2ac6&scoped=true"
const script = {}

import "./TNovoProfissional.vue?vue&type=style&index=0&id=672b2ac6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672b2ac6"]])

export default __exports__